import React from 'react';
import styled from 'styled-components';
import Lead from '../../components/Lead';
import imgMe from '../../images/me.jpg';

const Img = styled.img`
  float: none;
  width: 270px;
  padding: 0;
  margin: 2rem auto;
  display: block;

  @media (min-width: 640px) {
    margin: 0 1rem 1rem;
    float: right;
  }
`;

const Me = () => {
  return (
    <div>
      <h2>About Me</h2>
      <Lead>Hello. My name is Ian Willmott, a McTimoney chiropractor based in Filton Park, Bristol.</Lead>
      <Img src={imgMe} alt="Willmott standing near the beach" />
      <p>In April 1998, I embarked on a one year round the world trip with my now wife. Not knowing what
        would happen or where we would end up, we found ourselves nine months later on a tiny island
        in Indonesia. With no running water, electricity or tourists and nothing but crystal clear
        sea and white beaches it should’ve been paradise; if it wasn’t for my constant back pain.
        Nine months of lugging my worldly possessions around in my rucksack and sleeping on buses
        and floors had finally taken its toll, and my body was telling me to stop.</p>

      <p>I have never been a fan of pain killers but found myself succumbing to the likes of ibuprofen
        and paracetamol, all to little effect. Luckily a local man, I assume in his 70's,
        walked past me saying the only English word he new – 'massage'. I responded in
        Indonesian with 'good morning’ but did not treat him to my further wealth of
        knowledge in his language which comprised of 'two beers, one nasi goring
        and one chicken satay please'!
      </p>

      <p>Aided by the universal method of pointing, grunting and facial expressions of
        grimacing and pain, he grasped the fact that my lower back hurt. What happened
        next took me by surprise in that he spent little time working on my back at
        the exact point of the pain, but seemed to be tracing the cause of the pain
        via my muscles all the way though my hamstrings down to my feet.
      </p>

      <p>Forty five minutes of stretching and manipulation followed and he was finished.
        Quite frankly so was I. The rest of the day was a right off, as too the following
        24 hours. Remarkably, the day after that I felt fantastic and didn’t experience
        the same pain again for the remainder of my trip. I hadn’t deliberately left
        the UK on a sole searching mission but this one experience seemed to have found my vocation in life.
      </p>

      <p>On arrival back in the UK I recalled this story to a friend. They suggested I
        looked into becoming a McTimoney chiropractor as the techniques and philosophy
        appeared quite similar.
      </p>

      <p>Five years later I graduated from the McTimoney College based in Abingdon,
        Oxford, and have been practicing out of Bristol ever since. I have a keen
        interest in sports injuries and in particular preventing injury in the
        first instance. This sees me working with runners, golfers, tennis players
        rugby players and the like. I have also trained in Soft Tissue Release (STR)
        and Muscle Energy Technique (MET) which I combine with my chiropractic adjustments
        to provide a thorough, full body treatment.</p>

      <p>If you would like to experience the McTimoney technique, please feel
        free to get in touch. Thanks for visiting my website and I hope to see you soon.</p>

      <em>Ian</em>
    </div>
  );
};

export default Me;



// WEBPACK FOOTER //
// ./src/pages/about/me.js